import * as yup from 'yup';


export const commonAdditionalChargeValidation: { [x: string]: any; } = {
  opsDate: yup.date().required("Missing."),
  chargeOnCompany: yup.string().required("Missing."),
  billToCompany: yup.string().required("Missing."),
  chargeType: yup.string().required("Missing."),
  chargeQtyUom: yup.string().required("Missing."),
  tariffType: yup.string().required("Missing."),
  tariffCode: yup.string().required("Missing."),
  chargeQty: yup.number().required("Missing."),
};
export const cntrAdditionalChargeValidation: { [x: string]: any; } = {
  // ...commonAdditionalChargeValidation,
  cntrSize: yup.string().required("Missing."),
  cntrType: yup.string().required("Missing."),
  cntrStatus1: yup.string().required("Missing."),
};
export const uomAdditionalChargeValidation: { [x: string]: any; } = {
  // ...commonAdditionalChargeValidation,
  fromDate: yup.date().required("Missing."),
  toDate: yup.date().required("Missing."),
};

export const createAdditionalChargeValidation: { [x: string]: any; } = {
  ...commonAdditionalChargeValidation,
};
export const createCntrAdditionalChargeValidation: { [x: string]: any; } = {
  ...cntrAdditionalChargeValidation,
};
export const createUomAdditionalChargeValidation: { [x: string]: any; } = {
  ...uomAdditionalChargeValidation,
};

export const createAdditionalChargeValidationSchema = yup.object().shape(createAdditionalChargeValidation);
export const createCntrAdditionalChargeValidationSchema = yup.object().shape(createCntrAdditionalChargeValidation);
export const createUomAdditionalChargeValidationSchema = yup.object().shape(createUomAdditionalChargeValidation);

